import { sequenceStepTypes, sequenceAutomationTypes } from '@/src/constants/sequenceConstants.js';
import { getPlainTextLength } from '@/src/utils/quillUtils.js';

export const isHtmlEmpty = (html) => {
  if (!html) return true;
  return getPlainTextLength(html) === 0;
};

export const stepUsesVariants = (step) => {
  if (!step) return false;
  if (
    [
      "PHONE_CALL",
      "NEXT_BEST_ACTION",
      "MULTI_THREADING",
      "VOICE",
      "MARKET_RESEARCH",
    ].includes(step.step_type)
  ) {
    return false;
  }
  if (
    step.automation_type === "TASK" &&
    [
      "WHATSAPP_MESSAGE",
      "LINKEDIN_INVITE",
      "LINKEDIN_INMAIL",
      "LINKEDIN_MESSAGE",
    ].includes(step.step_type)
  ) {
    return false;
  }
  return true;
};

export const isVariantEmpty = (variant, step) => {
  if (!stepUsesVariants(step)) return false;

  if (step.automation_type === sequenceAutomationTypes.AI) {
    return !(variant.instruction || '').trim();
  }

  switch (step.step_type) {
    case sequenceStepTypes.WHATSAPP_MESSAGE:
      return !variant.message;
    case sequenceStepTypes.EMAIL:
      if (isHtmlEmpty(variant.message)) return true;
      if (!variant.reply_previous_thread && !(variant.subject || '').trim()) return true;
      return false;
    case sequenceStepTypes.LINKEDIN_INMAIL:
      if (isHtmlEmpty(variant.message)) return true;
      if (!(variant.subject || '').trim()) return true;
      return false;
    case sequenceStepTypes.LINKEDIN_INVITE:
      return false;
    case sequenceStepTypes.LINKEDIN_MESSAGE:
      return isHtmlEmpty(variant.message);
    case sequenceStepTypes.PHONE_CALL:
    case sequenceStepTypes.TASK:
      return !(variant.message || '').trim();
    default:
      return false;
  }
};
